module.exports = __webpack_public_path__ + "media/customizations/chathampark/logo-new-778e50f91ae28649a342b2aea3f13662.png";